const einDashboard = {
  einDashboard: {
    installingSince: 'Installeert Enphase sinds',
    accountManager: 'Accountmanager',
    installationShare: 'Aandeel van Enphase Installaties',
    nps: 'Netto Promotor Score',
    viewDashboard: 'Bekijk Dashboard',
    quarterInfo: 'vanaf Q%{quarter},%{year} (Residentieel)',
    npsTooltip: `De Net Promotor Score is een index variërend van -100 tot 100 die de bereidheid van klanten meet om producten of diensten van een bedrijf aan te bevelen aan anderen. Deze score is gebaseerd op de beoordelingen die uw klanten geven in de Enlighten Mobile App voor uw diensten en is alleen zichtbaar voor u en Enphase. De standaardtermijn voor de gegevens is de laatste 13 maanden.`,
    activity: 'Activiteit',
    sites: 'Locatie',
    batteries: 'Batterijen',
    acb: 'ACB',
    certifications: 'Certificeringen',
    community: 'Community',
    storage: 'Opslaglocaties',
    lastInstalledLabel: 'geïnstalleerd in de afgelopen 12 maanden',
    lastCommissionedLabel: 'in bedrijf gesteld in de laatste 12 maanden',
    viewDetails: 'View Details',
    seeReviews: 'Zie Beoordelingen',
    viewCommunity: 'Bekijk Community',
    certificateLabel: '%{count} van %{totalCount} Certificatie voltooid',
    networkLabel: {
      one: '%{count} post, laatste post: %{postDate}',
      other: '%{count} berichten, laatste bericht: %{postDate}'
    },
    requestProductAccess: 'Producttoegang aanvragen',
    inverter: 'IQ-8',
    ensemble: 'Ensemble 2.0',
    permit: 'Vergunningshulp',
    sgip: 'SGIP-bijstand',
    learnMore: 'Meer informatie',
    aboutProduct: 'over het product',
    betaReleaseDate: 'Bèta-uitgiftedatum',
    requestEarlyAccess: 'Vroegtijdige toegang aanvragen',
    viewAllProduct: 'Bekijk alle producten',
    signUp: 'Schrijf me in',
    betaReleaseLabel: 'voor alle nieuwe bèta-productuitgaven',
    financing: 'Financieringssteun',
    digitalPlatform: 'Digitaal platform',
    lpp: 'LPP',
    requestedText: 'Verzoek om vervroegde toegang',
    grantedText: 'Bètatoegang verleend',
    products: 'Producten',
    ratingsReviews: 'Beoordelingen & Recensies',
    reviews: 'Beoordelingen',
    otherReviews: 'Andere beoordelingen',
    updateDetails: 'Update Details',
    totalSavings: 'Totale besparing',
    inLastYear: 'In de afgelopen 12 maanden',
    viewBreakdown: 'Uitsplitsing bekijken',
    leadsReceived: 'Ontvangen leads',
    leadsClosure: 'Sluiten Leads',
    leadsWon: 'Gewonnen Leads',
    creditAvailable: 'Krediet beschikbaar',
    buyMore: 'Meer kopen',
    messageFromCeo: 'Bericht van onze CEO',
    communityUpdates: 'Community updates',
    makeAppointments: 'Afspraken maken',
    applicableText: 'Alleen van toepassing op platina leden',
    view: 'Bekijk',
    downloadAll: 'Download alle',
    promoteText: `Promoot uw bedrijf met badges en logo's`,
    asOfText: 'Vanaf: %{date}',
    yearTotal: 'Totaal/jaar',
    redeemed: 'Gebruikt',
    laborProtectionPlan: 'Programma voor arbeidsbescherming',
    acmPromotion: 'ACM Promotie',
    save: {
      lre_data: 'Besparingen van LPP',
      permit_data: 'Besparingen uit vergunningen',
      financing_data: 'Besparingen op de financiering',
      sgip_data: 'Besparingen van SGIP',
      warrantyExtension: 'Besparing op Garantieverlenging'
    },
    platinumLogo: 'Platina logo',
    enphaseLogo: 'Enphase logo',
    otherAssets: 'Andere middelen',
    ensembleCertificate: 'Ensemble 1.0 Gecertificeerd',
    salesCertificate: 'Verkoop 1,0 Gecertificeerd',
    marketingCertificate: 'Marketing 1.0 Gecertificeerd',
    solarInstallCertificate: 'Zonne-installatie gecertificeerd',
    validTill: 'Geldig tot: %{date}',
    noDataAvailable: 'Geen gegevens beschikbaar',
    notAvailable: 'Niet beschikbaar',
    notApplicable: 'Niet van toepassing',
    title: 'EIN Dashboard',
    congratulationSignUp: 'Gefeliciteerd! Nu heeft u vroegtijdig toegang tot elk nieuw Enphase product/dienst',
    benefits: 'Voordelen',
    installationShareTooltip:
      'Dit getal geeft aan welk percentage van uw totale installaties Enphase installaties zijn geweest.',
    dataFromThirdParty: '*Zoals per gegevens van een derde partij',
    reviewsNotAvailable: 'Geen beoordelingen beschikbaar',
    enphaseExecutive: 'Enphase Directie',
    digitalAssets: 'Digitale middelen',
    leads: 'Leads',
    tierSavings: 'Besparing Niveau',
    exclusiveUpdates: 'Exclusieve updates',
    executiveSponsor: 'Uitvoerend Sponsor',
    merchandise: 'Handelswaar',
    certifiedUsers: 'Gecertificeerde gebruikers',
    noteAllowedOnce: 'Let op: The bovenstaande link kan niet bewerkt worden wanneer deze is aangemaakt',
    saveLink: `Link opslaan`,
    confirm: `Bevestig`,
    copyLink: 'Link kopiëren',
    allowedCharactersError:
      'Alleen letters, cijfers, koppelteken en onderstrepingsteken zijn toegestaan (max. 500 tekens)',
    createSystemEstimatorLink: `Maak uw gepersonaliseerde System Estimator link en deel deze met uw klanten om leads van hen te krijgen. Elke lead die via deze link wordt gegenereerd, wordt alleen met u gedeeld in uw enlighten manager.`,
    shareSystemEstimatorLink: `Deel uw gepersonaliseerde System Estimator link met uw klanten om leads van hen te krijgen. Elke lead die via deze link wordt gegenereerd, wordt alleen met u gedeeld in uw enlighten manager.`,
    systemEstimatorLink: 'Systeem schatting link',
    confirmChanges: 'Bevestig wijzigingen',
    confirmSELink:
      'Bevestig uw systeem schatting link. Deze link is niet meer te bewerken als hij eenmaal is opgeslagen.',
    copied: `Gekopieerd`,
    mySELink: 'Mijn systeem schatting link',
    sdtUrlExistsError: 'This link is already in use by another installer. Please choose a different link',
    all: 'Allemaal',
    filterText: 'Filter',
    noProductAvailable: 'Geen product beschikbaar'
  }
};

export default einDashboard;
